import React, { useState } from 'react';
import logo from '../img/logo.png';
import '../styles/hero.css';

const Hero = () => {
  const [showText, setShowText] = useState(false);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
     <section id="hero" className="hero-wrapper">
  <div className="hero-content">
    <div
      className={`logo-container ${showText ? 'slide-right' : ''}`}
      onClick={() => setShowText(true)}
    >
      <img src={logo} alt="Logo" className="hero-logo" />
    </div>

    <div className={`hero-text ${showText ? 'slide-in' : ''}`}>
      <h1 className="display-5 fw-bold mb-4 text-dark">Rechtsberatung auf Augenhöhe.</h1>
      <p className="text-dark">
        Schnelle und unkomplizierte Lösungen – für Ihr Unternehmen und Ihre privaten Anliegen. Spezialisiert auf IT-Recht, Compliance und zivilrechtliche Fragestellungen vertreten wir Ihre Interessen. <br />Digital, klar und wirkungsvoll.
      </p>
      <button
            className="btn btn-dark mt-4"
            onClick={() => scrollToSection('kontakt')}
          >
            Jetzt Erstgespräch vereinbaren
          </button>
    </div>
  </div>
</section>

  );
};

export default Hero;
